/* Third Party */
import '@babel/polyfill'
import Vue from 'vue'
import { sync } from 'vuex-router-sync'

/* Sentry */
import './tracking/sentry'

/* App */
import App from './App'
import store from './store'
import router from './routes'
import { i18n } from './config'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faBell,
  faQuestionCircle,
  faPlayCircle,
  faPen,
  faClone,
  faTrash,
  faChevronLeft,
  faPlus,
  faDesktop,
  faMobile,
  faChevronRight,
  faTags,
  faCheck,
  faEdit,
  faExternalLink,
  faLink,
  faBookmark,
  faExpand,
  faCrop,
  faHome,
  faPhoneLaptop,
  faUndo,
  faTimes,
  faSearch,
  faBox,
  faInfoCircle,
  faCog,
  faTag,
  faCheckCircle,
  faCircleX,
  faBullhorn,
  faPencil,
  faArrowUpFromBracket,
  faCircleInfo,
  faTriangleExclamation,
  faXmark
} from '@fortawesome/pro-light-svg-icons'

import {
  faCircle,
  faEye,
  faImage,
  faImages,
  faArrowDown
} from '@fortawesome/pro-solid-svg-icons'

import {
  faSignOut,
  faEllipsisV,
  faArrowUpRight,
  faTrophyStar,
  faCheckCircle as faCheckCircleRegular
} from '@fortawesome/pro-regular-svg-icons'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faSignOut,
  faBell,
  faCircle,
  faQuestionCircle,
  faPlayCircle,
  faEllipsisV,
  faEye,
  faPen,
  faClone,
  faTrash,
  faChevronLeft,
  faPlus,
  faDesktop,
  faMobile,
  faChevronRight,
  faTag,
  faTags,
  faCheck,
  faEdit,
  faExternalLink,
  faLink,
  faBookmark,
  faExpand,
  faImage,
  faImages,
  faCrop,
  faHome,
  faPhoneLaptop,
  faUndo,
  faTimes,
  faSearch,
  faBox,
  faInfoCircle,
  faCog,
  faCheckCircle,
  faCheckCircleRegular,
  faCircleX,
  faBullhorn,
  faArrowUpRight,
  faTrophyStar,
  faArrowDown,
  faPencil,
  faArrowUpFromBracket,
  faCircleInfo,
  faTriangleExclamation,
  faXmark
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

sync(store, router)

Vue.config.productionTip = false

const app = new Vue({
  name: 'root',
  i18n,
  router,
  store,
  render: (mount) => mount(App)
})

router.onReady(() => {
  app.$mount('#app')
})

export default app
